// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3MZ-u","head":"ProcedureTableInfo_head__2Ejg_"};